import {
  INVITATIONSOURCETYPE_CSV,
  INVITATIONSOURCETYPE_EXCEL,
} from '../../../../../../../constants/api';
import { getAttr } from '../../../../../../../features/helpers/apiHelpers';
import csvFile from '../../../../../../../files/Deltagerliste_eksempel.csv';
import excelFile from '../../../../../../../files/Deltagerliste_eksempel.xlsx';

export function getConfiguration(invitationSource) {
  const invitationSourceType = getAttr(
    invitationSource,
    'invitationSourceType',
  );

  const maxFileSizeInBytes = 2 * Math.pow(10, 6);
  let fileExtension = '';
  let exampleFileToDownload = '';
  let file = '';

  if (invitationSourceType === INVITATIONSOURCETYPE_CSV) {
    fileExtension = 'csv';
    exampleFileToDownload = 'Deltagerliste_eksempel.csv';
    file = csvFile;
  } else if (invitationSourceType === INVITATIONSOURCETYPE_EXCEL) {
    fileExtension = 'xlsx';
    exampleFileToDownload = 'Deltagerliste_eksempel.xlsx';
    file = excelFile;
  }

  return { file, fileExtension, maxFileSizeInBytes, exampleFileToDownload };
}
